import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { UsersTable } from './components';
import {
  GetInterestedStudentsAPIReq
} from '../../utils/requests';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));


let isLoading = true;

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

const getInterestedStudentsData = async (forceUpdate, history) =>{
  if(isLoading){
    return GetInterestedStudentsAPIReq()
      .then((res) => {
        if(res){
          if(res[0] === 0){
            isLoading = false;
            data = res[1];
            forceUpdate();
          } else if(res[0] === 2){
            // console.log(res);
            alert('Session Expired');
            history.push('/sign-in');
          }else if(res[0] === 1){
            alert('An arror happened while fetching for data');
          }
        }
      })
  }
}
let data;
const UserList = (props) => {

  const { history } = props;
  // const data = getData()
  const classes = useStyles();
  const forceUpdate = useForceUpdate();
  getInterestedStudentsData(forceUpdate, history);
  return(
    <div>
      {isLoading?
        <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '200px', marginBottom: '200px'}}>
          <CircularProgress disableShrink />
        </div>
        :
        <div>
            <UsersTable users={data} history={history}/>
        </div>
      }
    </div>)

};


UserList.propTypes = {
  history: PropTypes.object
};

export default UserList;
